import React from 'react';
import PropTypes from 'prop-types';
function SuccessMessage(props) {
  if (props.message) {
    return (
      <div className="success-message mb-3 d-flex align-items-center justify-content-center shadow-none" elevation={2}>
        <p className="mb-0">{props.message}</p>
      </div>
    );
  } else {
    return null;
  }
}

SuccessMessage.propTypes = {
  message: PropTypes.string,
};

export default SuccessMessage;
